<template v-slot:activator="{ on }">
    <v-menu
      v-model="menu"
      bottom
      offset-y
      :close-on-content-click="false"
      style="z-index: 999">
      <template v-slot:activator="{ on: menu }">
        <v-btn v-on="{ ...menu }" plain>
          <StatusAvatar :user="currentUserWithStatus"/>
        </v-btn>
      </template>

      <v-card v-if="currentUser" min-width="320px" max-width="400px" style="z-index: 999">
        <v-list>
          <v-list-item>
            <v-list-item-title><span>{{currentUser.firstName}} {{currentUser.lastName}}</span></v-list-item-title>
            <v-list-item-action class="my-0 mr-1">
              <v-btn icon v-if="canAccess" :to="{name: 'settings'}" @click="menu = !menu" data-testid="toolbar-currentUser-settings-btn">
                <v-icon>mdi-cog</v-icon>
              </v-btn>
            </v-list-item-action>
          </v-list-item>
          <v-list-item>
            <v-list-item-action>
              <StatusAvatar :user="currentUserWithStatus" :showEditHover="true" :show-tooltip="false" data-testid="toolbar-currentUser-avatar"/>
            </v-list-item-action>

            <v-list-item-content>
              <v-list-item-subtitle><v-icon small color="grey">mdi-phone</v-icon> x{{ currentUser.extension }}</v-list-item-subtitle>
              <v-list-item-subtitle><v-icon small color="grey">mdi-domain</v-icon> {{ currentUser.company }}</v-list-item-subtitle>
              <v-list-item-subtitle v-if="hasUserDID"><v-icon small color="grey">mdi-phone-incoming</v-icon> {{ userDIDs }}</v-list-item-subtitle>
            </v-list-item-content>

            <v-list-item-action class="ma-0">
              <span class="mr-1 mb-1"><RMQClientHint data-testid="toolbar-currentUser-rmqstatus"/></span>
              <ChatUserPresence v-if="canChatsRead"/>
            </v-list-item-action>
          </v-list-item>
        </v-list>

        <v-divider></v-divider>

        <v-list data-testid="toolbar-currentUser-content-list">
          <v-list-item>
            <v-list-item-action>
              <DarkModeSwitch @switched="onSwitchTheme()" :initialState="$vuetify.theme.dark" v-if="$vuetify.theme" data-testid="toolbar-currentUser-themeswitch"/>
            </v-list-item-action>
            <v-list-item-title>{{ $t('tb.currentUser.theme') }}</v-list-item-title>
          </v-list-item>
          <v-list-item>
            <v-list-item-action class="ml-3 mr-7">
              <LangMenu data-testid="toolbar-currentUser-langswitch"/>
            </v-list-item-action>
            <v-list-item-title>{{ $t('tb.currentUser.language') }}</v-list-item-title>
          </v-list-item>
        </v-list>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text color="red" class="mr-5"
            data-testid="toolbar-currentUser-signout-btn"
            id="signout-btn" @click="signout">
            {{ $t('tb.signout') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-menu>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import LangMenu from './translate'
import DarkModeSwitch from 'vue-dark-mode-switch'
import Session from '@/api/session'
import RMQClientHint from './rmqclient_hint'
import ChatUserPresence from './chatpresence'
import API from '@/api'
import StatusAvatar from '@/components/buddies/status_avatar'

// workaround for tests
if (process.env.NODE_ENV !== 'test') {
  import('vue-dark-mode-switch/dist/vue-dark-mode-switch.css').then((something) => {
  })
}
export default {
  name: 'current-user-menu',
  components: { DarkModeSwitch, LangMenu, RMQClientHint, ChatUserPresence, StatusAvatar },
  data () {
    return {
      menu: false
    }
  },
  computed: {
    ...mapGetters({
      canAccess: 'permissions/hasAccess',
      canChatsRead: 'permissions/chatsRead',
      currentUser: 'currentUser/currentUser',
      buddies: 'users/buddies'
    }),
    hasUserDID: function () {
      return this.currentUser?.did?.length > 0
    },
    userDIDs: function () {
      return this.currentUser?.dids?.join(' ')
    },
    currentUserWithStatus () {
      const buddyUser = this.buddies.find((user) => user.exten === this.currentUser?.extension)
      if (buddyUser) {
        return buddyUser
      }
      return this.currentUser
    }
  },
  methods: {
    ...mapActions({
      authReset: 'authReset',
      sipuaDestroy: 'sipuaDestroy'
    }),

    signout: async function () {
      Session.clear()
      this.authReset()
      await this.sipuaDestroy()
      window.location.href = API.baseURLPath('signout')
    },

    onSwitchTheme () {
      this.$vuetify.theme.dark = !this.$vuetify.theme.dark
      localStorage.setItem('DarkMode', JSON.stringify(this.$vuetify.theme.dark))
    }
  }
}
</script>

<style>
</style>
